import { observer } from 'mobx-react-lite'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import { PlatformContainer, PlatformContainerProps } from './PlatformContainer'
import SlideUpTransition, { defaultSlideUpDuration } from 'reusable/transitions/SlideUpTransition'
import ModalState from 'reusable/mobx-helpers/ModalState'

export interface PlatformContainerDialogProps extends Omit<PlatformContainerProps, 'onClose'> {
   state: ModalState
   dialogProps?: Omit<DialogProps, 'open' | 'fullscreen'>
}

export const PlatformContainerDialog = observer(function PlatformContainerDialog({ state, dialogProps, ...platformContainerProps }: PlatformContainerDialogProps) {
   return (
      <Dialog
         fullScreen
         TransitionComponent={SlideUpTransition}
         transitionDuration={defaultSlideUpDuration}
         open={state.visible}
         onClose={state.close}
      >
         <PlatformContainer {...platformContainerProps} onClose={state.close} />
      </Dialog>
   )
})
